export const faqData = [
 {
  category: "سوالات مرتبط با واحد فروش",
  questions: [
   {
    question: "1) فرایند خرید خودرو از شرکت برساوش به چه صورت است؟",
    answer:
"متقاضیان خرید خودروهای هیبریدی و بنزینی می‌توانند از طریق «سامانه جامع فروش خودرو (فروش یکپارچه)» نسبت به ثبت‌نام و انتخاب خودروی مورد نظر خود اقدام کنند. پس از تکمیل مراحل خرید، پرونده آن‌ها به شرکت برساوش ارجاع داده می‌شود و ادامه روند خرید و تحویل خودرو توسط این شرکت پیگیری خواهد شد<br/>.همچنین، متقاضیان خرید خودروهای برقی می‌توانند با مراجعه به وب‌سایت <a href='https://www.barsavosh.co' class='text-blue-500'>barsavosh.co </a>درخواست خود را ثبت کنند. پس از تکمیل اطلاعات مورد نیاز، کارشناسان و مشاوران شرکت با متقاضیان تماس گرفته و مراحل بعدی فروش را هماهنگ خواهند کرد."
   },

   {
    question: "2) چه مدل‌هایی از خودروها در حال حاضر توسط برساوش عرضه می‌شوند؟",
    answer: "خودروهای عرضه‌شده توسط شرکت برساوش شامل مدل‌های: <a href='https://www.barsavosh.co/products/7' class='text-blue-700'> Levin Turbo </a>، <a href='https://www.barsavosh.co/products/7' class='text-blue-700'> Levin Hybrid </a>، <a href='https://www.barsavosh.co/products/8' class='text-blue-700'> Crolla Cross </a> ، <a href='https://www.barsavosh.co/products/14' class='text-blue-700'> KIA K5 </a> ، <a href='https://www.barsavosh.co/products/15' class='text-blue-700'> KIA Sportage </a>،<a href='https://www.barsavosh.co/products/11' class='text-blue-700'> Land-Cruiser-VXR </a>،<a href='https://www.barsavosh.co/products/12' class='text-blue-700'> Land-Cruiser-Prado </a>، <a href='https://www.barsavosh.co/products/13' class='text-blue-700'> RAV4-2.0L </a> ،<a href='https://www.barsavosh.co/products/17' class='text-blue-700'> RAV4-2.5L </a>،<a href='https://www.barsavosh.co/products/9' class='text-blue-700'> BZ4 </a>،<a href='https://www.barsavosh.co/products/10' class='text-blue-700'> BZ3 </a> هستند."
   },
   {
    question: "3) آیا امکان بازدید حضوری از خودروها در شوروم وجود دارد؟",
    answer:
     "بله ، شوروم مرکزی شرکت برساوش واقع در اتوبان آزادگان ، ورودی احمد آباد مستوفی قرار دارد و امکان بازدید حضوری و تست خودرو ها در آن فراهم است."
   },
   {
    question: "4) از چه طریق می‌توان خودروها را از نزدیک مشاهده کرد؟",
    answer:
     "با هماهنگی و تعیین وقت قبلی با واحد فروش و مراجعه به دفتر مرکزی شرکت برساوش واقع در اتوبان آزادگان ، ورودی احمد آباد مستوفی امکان بازدید حضوری فراهم می باشد."
   },
   {
    question: "5) خودروهای برقی ارائه شده توسط برساوش در حال حاضر شامل چه مدل‌هایی هستند؟",
    answer:
     "در حال حاضر، دو مدل خودروی برقی <a href='https://www.barsavosh.co/products/9' class='text-blue-700'> BZ4 </a>،<a href='https://www.barsavosh.co/products/10' class='text-blue-700'> BZ3 </a> توسط شرکت برساوش عرضه شده‌اند و در آینده‌ای نزدیک، مدل های متنوع تری از خودروهای برقی به سبد محصولات شرکت افزوده خواهند شد."
   },
   {
    question: "6) آیا در محل شوروم یا نمایندگی‌ها، جایگاه شارژ خودروهای برقی وجود دارد؟",
    answer:
     "بله ، در حال حاضر چند جایگاه شارژ برقی در دفتر مرکزی واقع در انتهای اتوبان آزادگان ، ورودی احمد آباد مستوفی فعال است؛ در نمایندگی ها امکان پذیر نیست ولی با توجه به روند تجهیز و توسعه شبکه فروش این قابلیت در آینده نزدیک در نمایندگی ها نیز فراهم خواهد شد ."
   },
   {
    question: "7) شرایط فروش اقساطی یا لیزینگ برای محصولات برساوش چگونه است؟",
    answer:
     "در حال حاضر، با توجه به انجام فرآیند فروش از طریق سامانه جامع فروش خودرو، امکان فروش اقساطی یا لیزینگ برای محصولات وجود ندارد."
   },
   {
    question: "8) آیا امکان پیش خرید خودروهای جدید یا در حال ورود وجود دارد؟",
    answer:
     "در زمان عرضه خودرو های جدید توسط شرکت برساوش، ثبت نام از طریق سامانه فروش خودرو امکان پذیر است."
   },
   {
    question: "9) مدت زمان تحویل خودرو بعد از ثبت سفارش چقدر است؟",
    answer:
     "بر اساس نوع فروش ،زمان تحویل خودرو در شرکت برساوش بین 90 روز کاری تا 120 روز کاری متغیر است ."
   },
   {
    question: "10) آیا قبل از انعقاد قرارد نیاز به واریز وجه می باشد؟",
    answer:
     "خیر قبل از انعقاد قرارداد نیازی به واریز وجه نیست."
   },
   
  ]
 },
 {
  category: "سوالات مرتبط با واحد خدمات پس از فروش",
  questions: [
   {
    question: "1) فواصل سرویس های دوره ای چگونه است ؟",
    answer:
     "فواصل سرویس‌های  سرویس‌های هر 5  هزار کیلومتر یا ۶ ماه یک‌بار می بایستی در شبکه خدمات پس از فروش شرکت برساوش انجام گردد."
   },
   {
    question: "2) آیا سرویس در تعمیرگاه یا نمایندگی غیر مجاز گارانتی خودرو را باطل می کند؟",
    answer:
     "بله، اگر سرویس‌ها یا تعمیرات در مراکز غیرمجاز انجام شود، شرکت می‌تواند گارانتی خودرو را به صورت کامل یا  بخش‌های مرتبط را ابطال کند."
   },
   {
    question: "3) برای دریافت نوبت تعمیرگاه چه کاری باید انجام دهیم؟",
    answer:
     "می‌توانید از طریق رزرو آنلاین، تماس تلفنی یا مراجعه حضوری برای نوبت‌گیری اقدام کنید."
   },
   {
    question: "4) در صورت خرابی خودرو در جاده چه کاری باید انجام دهیم؟",
    answer:
     "با  مرکز تماس شرکت برساوش 1852 داخلی 1 و 2 امداد خودرو های تویوتا و کیا تماس بگیرید. خدماتی ازجمله حمل، باتری کمکی، پنچرگیری، تعویض زاپاس و حمل سرنشین انجام می پذیرد."
   },
   {
    question: "5) هزینه سرویس های دوره ای چگونه محاسبه می شود؟",
    answer:
     "هزینه شامل اجرت کار، قطعات مصرفی و مواد جانبی بوده و پیش از کار فاکتور تقریبی ارائه می‌شود."
   },
   {
    question: "6) چه تعمیراتی در پوشش گارانتی قرار می گیرند؟",
    answer:
     "گارانتی شامل موتور، گیربکس، سیستم برق و قطعات الکترونیکی است. قطعات مصرفی شامل گارانتی نمی‌شوند."
   },
   {
    question: "7) چه مواردی باعث ابطال گارانتی می شوند؟",
    answer:
     "عدم انجام سرویس‌ها در زمان مقرر، استفاده از قطعات غیراصل، تعمیر در مراکز غیر مجاز، دستکاری کیلومتر شمار."
   },
   {
    question: "8) مدت زمان گارانتی خودروها چه میزان می باشد؟ ",
    answer:
     "گارانتی خودروهای شرکت برساوش 3 سال یا 60 هزار کیلومتر ( هر کدام که زودتر فرا برسد ) می باشد."
   },
   {
    question: "9) مدت زمان گارانتی باتری خودروهای برقی چقدر است؟",
    answer:
     "مدت زمان گارانتی باتری خودروهای برقی شرکت برساوش 5 سال یا 160 هزار کیلومتر ( هرکدام که زودتر فرا برسد ) می باشد."
   },
   {
    question: "10) آیا خرید شارژر های خودرو های برقی سایر شرکت ها امکان پذیر می باشد؟",
    answer:
     "بله شرکت برساوش شارژرهای وال باکس 32 آمپر و شارژرهای پرتابل 16 آمپر را جهت فروش به کلیه مصرف کنندگان خودروهای برقی عرضه می نماید."
   },
   {
    question: "11) گارانتی انواع شارژرهای شرکت برساوش ( وال باکس _ پرتابل ) چه میزان می باشد؟ ",
    answer:
     "گارانتی انواع شارژهای شرکت برساوش 1 سال می باشد."
   },
  ]
 },
 {
  category: "سوالات مرتبط با واحد فنی و مهندسی",
  questions: [
   {
    question: "1) محصولات وارداتی برساوش تحت چه گارانتی یا ضمانتی ارائه میشوند؟",
    answer:
     "محصولات شرکت برساوش تحت پوشش ضمانت‌نامه رسمی شرکت برساوش تجارت نیک قرار دارند. این گارانتی از نوع «کلیم داخلی» بوده و شامل خدمات پس از فروش مطابق با استانداردهای شرکت اصلی می‌باشد.<br><br> تمامی محصولات برساوش با ضمانت‌نامه معتبر خود شرکت برساوش تجارت نیک ارائه می‌شوند. این گارانتی از نوع «کلیم داخلی» است، یعنی در صورت بروز مشکل، مستقیماً و بدون واسطه توسط خود ما پیگیری و پشتیبانی خواهد شد تا خیال شما از خدمات پس از فروش راحت باشد. "
   }
  ]
 },
 {
  category: "سوالات مرتبط با واحد قطعات",
  questions: [
   {
    question: "1) گارانتی قطعات تعویض شده به چه میزانی می باشد؟",
    answer:
     "گارانتی قطعات تعویض شده در نمایندگی های مجاز شرکت برساوش 6 ماه یا 10 هزار کیلومتر هر کدام که زودتر فرا برسد می باشد."
   },
   {
    question: "2) آیا نصب آپشن های اضافه توسط شرکت برساوش بر روی خودروها اخلالی در وضعیت  گارانتی خودرو ایجاد نمی کند؟",
    answer:
     "خیر ، شرکت برساوش با تیمی متخصص و آموزش دیده و با استفاده از قطعات اورجینال کلیه خدمات نصب و آپشنال نمودن خودرو های تویوتا و کیا را انجام خواهند داد، کلیه قطعات قبل از نصب تحت تست های فنی قرار می گیرند،کلیه قطعات تعویض شده با گارانتی 18 ماهه ارائه می گردد."
   }
  ]
 },
 {
  category: "سوالات مرتبط با واحد شبکه نمایندگی",
  questions: [
   {
    question: "1) چگونه از ادرس و شماره تماس نمایندگی های فروش و خدمات پس از فروش شرکت برساوش اطلاع پیدا کنم؟",
    answer:
     "جهت دریافت اطلاعات تماس با نمایندگان به وب سایت شرکت برساوش به آدرس <a href='https://www.barsavosh.co' class='text-blue-500'>www.barsavosh.co </a> یا شماره تماس 1852 تماس حاصل فرمایید."
   },
   {
    question: "2) چرا در برخی از نمایندگی ها قیمت قطعات و اجرت خدمات متفاوت است؟",
    answer:
     "قیمت قطعات در کلیه نمایندگی های خدمات پس از فروش شرکت برساوش یکسان می باشد. در خصوص اجرت با توجه به رتبه بندی نمایندگی های خدمات پس از فروش و منطقه بندی این نمایندگی ها که به صورت سالانه از سوی شرکت بازرسی تعیین و اعلام می گردد هزینه اجرت متفاوت می باشد.<br/>جهت مشاهده رتبه بندی نمایندگی ها می توان به سایت شرکت برساوش به آدرس  <a href='https://www.barsavosh.co' class='text-blue-500'>www.barsavosh.co </a> مراجعه فرمایید."
   },
  ]
 },
 {
  category: "سوالات مرتبط با واحد شکایات مشتریان",
  questions: [
   {
    question: "1) جهت ثبت شکایات از نمایندگی چگونه باید اقدام کنیم؟",
    answer:
     "با مراجعه به واحد CRM شرکت برساوش به صورت مراجعه حضوری، وب سایت شرکت برساوش، ارسال ایمیل به آدرس crm@barsavosh.co و یا تماس با شماره تلفن 1852 داخلی 3 امکان ثبت شکایت برای مشتریان وجود دارد.<br/>آدرس وب سایت شرکت برساوش <a href='https://www.barsavosh.co' class='text-blue-500'>www.barsavosh.co </a> می باشد."
   }
  ]
 }
];